import { Component, HostBinding, HostListener, Input, inject, input } from '@angular/core';

import { GridConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ShowInEpcotDirective } from '@frontend/sports/common/core/feature/show-in-epcot';
import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { GridEvent } from '@frontend/sports/grid/core/feature/model';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { DeviceService } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { BadgeComponent } from '../../crm-promotion/badge.component';
import { EventInfoComponent } from './event-info.component';
import { GameNotesComponent } from './game-notes.component';

@Component({
    selector: 'ms-event-footer',
    templateUrl: './event-footer.component.html',
    styleUrls: ['./event-footer.component.scss'],
    imports: [GameNotesComponent, EventInfoComponent, BadgeComponent, ShowInEpcotDirective, IconCustomComponent, StringInterpolationPipe],
})
export class EventFooterComponent {
    sitecore = inject(Sitecore);
    private deviceService = inject(DeviceService);
    private redirectHelper = inject(RedirectHelperService);
    gridConfig = inject(GridConfig);

    @Input() event: GridEvent;
    @Input() eventUrl: string;
    @Input() mediaEnabled: boolean;
    @Input() promotedFixtureIdsMap: StringDictionary<string> = {};
    @Input() showEventTimerInfoSection?: boolean;
    @Input() showFixedFooterSection?: boolean;
    @Input() isGameNotesVisible = false;
    @Input() gameNotes?: string;
    showPlayerStatisticsButton = input(false);

    @HostBinding('class') className = 'footer-event';

    get isMobilePhone(): boolean {
        return this.deviceService.isMobilePhone;
    }

    @HostListener('click')
    eventClick(): void {
        this.redirectHelper.goToPage(this.eventUrl);
    }
}
